module.exports = __webpack_public_path__ + "img/no-ask.a9aa6fb3.svg";